// extracted by mini-css-extract-plugin
export default {"urgencyMessages":"UrgencySignalsNode-rebranding-module__urgencyMessages___PgXkb","wrapper":"UrgencySignalsNode-rebranding-module__wrapper___3_-7y"};